export const NOTIFICATION_KIND_NEW_EMPLOYEE_CREATED = "NEW_EMPLOYEE_CREATED";
export const NOTIFICATION_KIND_CUSTOM_ANNOUNCEMENT = "CUSTOM_ANNOUNCEMENT";
export const NOTIFICATION_KIND_NEW_USER_CREATED = "NEW_USER_CREATED";
export const NOTIFICATION_KIND_TEMPLATES_CUSTOM = "TEMPLATES_CUSTOM";
export const NOTIFICATION_KIND_ORDER_FINISHED = "ORDER_FINISHED";
